import React, { useEffect, useState } from 'react';
import { IInputProps } from '../../types/input.type';
import { ErrorSpan } from './error-span.component';
import { EyeIcon } from '../icons/eye-icon.component';
import { EyeSlashIcon } from '../icons/eye-slash-icon.component';

export const Input = ({
  placeholder,
  errors,
  name,
  register,
  type,
  label,
  icon,
  children,
  className = ''
}: IInputProps) => {
  const [isPassword, setIsPassword] = useState(false);
  const [inputType, setInputType] = useState(type);

  useEffect(() => {
    if (type === 'password') {
      setIsPassword(true);
    }
  }, [type]);

  const togglePassword = () => {
    setInputType((prev) => (prev === 'password' ? 'text' : 'password'));
  };

  return (
    <div className="relative">
      <label
        htmlFor={name}
        className="text-base-black font-body text-[14px] ml-[6px] font-medium"
      >
        {label}
      </label>

      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-[31px] -translate-y-1/2 pointer-events-none">
            {icon}
          </div>
        )}

        <input
          id={name}
          placeholder={placeholder}
          type={inputType}
          {...register(name)}
          className={`w-full md:max-w-[392px] h-[44px] mt-[8px] mb-[22px] pr-[40px] pl-[44px] py-[11px]
            text-[16px] font-body font-regular text-base-black bg-surface-base
            border rounded-[24px] placeholder-gray-900 placeholder:font-body
            focus:outline-none
            ${
              errors[name]
                ? 'border-red-500 text-red-500 placeholder-red-500'
                : 'border-gray-700 hover:border-blue-100 hover:bg-surface-base focus:border-blue-100 focus:bg-surface-base focus:shadow-[0_0_0_4px_rgba(93,225,255,0.20)]'
            }
            ${className}`} // ✅ додаємо кастомні класи
        />
      </div>

      {isPassword && (
        <button
          type="button"
          onClick={togglePassword}
          aria-label={inputType === 'password' ? 'Show password' : 'Hide password'}
          className="absolute right-5 md:right-4 top-10 h-8 flex items-center justify-center cursor-pointer hover:opacity-80"
        >
          {inputType === 'password' ? <EyeIcon /> : <EyeSlashIcon />}
        </button>
      )}

      {children}
      {errors[name] && <ErrorSpan>{errors[name].message}</ErrorSpan>}
    </div>
  );
};
